



const ChainCircle = () => {
    return (
    <svg version="1.1" viewBox="0 0 1920 2266" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink">
    <title>BG CIRCLE CHAIN section2@2x</title>
    <desc>Created with Sketch.</desc>
    <defs>
    <linearGradient id="a" x1="50%" x2="50%" y2="100%">
    <stop stop-color="#2DDCF4" offset="0"/>
    <stop stop-color="#8954F4" offset="1"/>
    </linearGradient>
    <ellipse id="ai" cx="1143.6" cy="1127.3" rx="1039.5" ry="1040.6"/>
    <mask id="dw" x="0" y="0" width="2079" height="2081.2" fill="white">
    <use href="#ai"/>
    </mask>
    <ellipse id="p" cx="1143.6" cy="1127.3" rx="1073.6" ry="1074.7"/>
    <mask id="dl" x="0" y="0" width="2147.2" height="2149.4" fill="white">
    <use href="#p"/>
    </mask>
    <circle id="co" cx="1811.7" cy="309.1" r="64.9"/>
    <mask id="gk" x="0" y="0" width="129.8" height="129.8" fill="white">
    <use href="#co"/>
    </mask>
    <circle id="cg" cx="1598.3" cy="173.8" r="64.9"/>
    <mask id="gd" x="0" y="0" width="129.8" height="129.8" fill="white">
    <use href="#cg"/>
    </mask>
    <circle id="bz" cx="1328.8" cy="103.4" r="64.9"/>
    <mask id="fv" x="0" y="0" width="129.8" height="129.8" fill="white">
    <use href="#bz"/>
    </mask>
    <circle id="bp" cx="2153.8" cy="815.1" r="64.9"/>
    <mask id="fl" x="0" y="0" width="129.8" height="129.8" fill="white">
    <use href="#bp"/>
    </mask>
    <circle id="bc" cx="2153.8" cy="815.1" r="64.9"/>
    <mask id="ez" x="0" y="0" width="129.8" height="129.8" fill="white">
    <use href="#bc"/>
    </mask>
    <circle id="aw" cx="2025.1" cy="529.1" r="64.9"/>
    <mask id="es" x="0" y="0" width="129.8" height="129.8" fill="white">
    <use href="#aw"/>
    </mask>
    <circle id="aa" cx="316.8" cy="485.1" r="64.9"/>
    <mask id="dy" x="0" y="0" width="129.8" height="129.8" fill="white">
    <use href="#aa"/>
    </mask>
    <circle id="x" cx="953.7" cy="2162.6" r="64.9"/>
    <mask id="dx" x="0" y="0" width="129.8" height="129.8" fill="white">
    <use href="#x"/>
    </mask>
    <circle id="w" cx="685.3" cy="2091.1" r="64.9"/>
    <mask id="dv" x="0" y="0" width="129.8" height="129.8" fill="white">
    <use href="#w"/>
    </mask>
    <circle id="v" cx="469.7" cy="1954.7" r="64.9"/>
    <mask id="du" x="0" y="0" width="129.8" height="129.8" fill="white">
    <use href="#v"/>
    </mask>
    <circle id="u" cx="257.4" cy="1736.9" r="64.9"/>
    <mask id="dt" x="0" y="0" width="129.8" height="129.8" fill="white">
    <use href="#u"/>
    </mask>
    <circle id="t" cx="140.8" cy="1481.7" r="64.9"/>
    <mask id="ds" x="0" y="0" width="129.8" height="129.8" fill="white">
    <use href="#t"/>
    </mask>
    <circle id="s" cx="1227.6" cy="2178" r="64.9"/>
    <mask id="dr" x="0" y="0" width="129.8" height="129.8" fill="white">
    <use href="#s"/>
    </mask>
    <circle id="r" cx="1496" cy="2128.5" r="64.9"/>
    <mask id="dq" x="0" y="0" width="129.8" height="129.8" fill="white">
    <use href="#r"/>
    </mask>
    <circle id="q" cx="1764.4" cy="1986.6" r="64.9"/>
    <mask id="dp" x="0" y="0" width="129.8" height="129.8" fill="white">
    <use href="#q"/>
    </mask>
    <circle id="o" cx="1966.8" cy="1778.7" r="64.9"/>
    <mask id="do" x="0" y="0" width="129.8" height="129.8" fill="white">
    <use href="#o"/>
    </mask>
    <circle id="n" cx="2115.3" cy="1552.1" r="64.9"/>
    <mask id="dn" x="0" y="0" width="129.8" height="129.8" fill="white">
    <use href="#n"/>
    </mask>
    <circle id="m" cx="1056" cy="88" r="64.9"/>
    <mask id="dm" x="0" y="0" width="129.8" height="129.8" fill="white">
    <use href="#m"/>
    </mask>
    <circle id="l" cx="786.5" cy="137.5" r="64.9"/>
    <mask id="dk" x="0" y="0" width="129.8" height="129.8" fill="white">
    <use href="#l"/>
    </mask>
    <circle id="k" cx="521.4" cy="279.4" r="64.9"/>
    <mask id="dj" x="0" y="0" width="129.8" height="129.8" fill="white">
    <use href="#k"/>
    </mask>
    <circle id="j" cx="173.8" cy="724.9" r="64.9"/>
    <mask id="di" x="0" y="0" width="129.8" height="129.8" fill="white">
    <use href="#j"/>
    </mask>
    <ellipse id="i" cx="800.55" cy="789.11" rx="727.65" ry="728.42"/>
    <mask id="dh" x="0" y="0" width="1455.3" height="1456.84" fill="white">
    <use href="#i"/>
    </mask>
    <ellipse id="h" cx="800.55" cy="789.11" rx="751.52" ry="752.29"/>
    <mask id="dg" x="0" y="0" width="1503.04" height="1504.58" fill="white">
    <use href="#h"/>
    </mask>
    <circle id="g" cx="1268.2" cy="216.37" r="45.43"/>
    <mask id="df" x="0" y="0" width="90.86" height="90.86" fill="white">
    <use href="#g"/>
    </mask>
    <circle id="f" cx="1118.8" cy="121.66" r="45.43"/>
    <mask id="de" x="0" y="0" width="90.86" height="90.86" fill="white">
    <use href="#f"/>
    </mask>
    <circle id="e" cx="930.16" cy="72.38" r="45.43"/>
    <mask id="dd" x="0" y="0" width="90.86" height="90.86" fill="white">
    <use href="#e"/>
    </mask>
    <circle id="d" cx="1507.7" cy="570.57" r="45.43"/>
    <mask id="dc" x="0" y="0" width="90.86" height="90.86" fill="white">
    <use href="#d"/>
    </mask>
    <circle id="c" cx="1507.7" cy="570.57" r="45.43"/>
    <mask id="db" x="0" y="0" width="90.86" height="90.86" fill="white">
    <use href="#c"/>
    </mask>
    <circle id="b" cx="1417.6" cy="370.37" r="45.43"/>
    <mask id="ha" x="0" y="0" width="90.86" height="90.86" fill="white">
    <use href="#b"/>
    </mask>
    <circle id="da" cx="221.76" cy="339.57" r="45.43"/>
    <mask id="gz" x="0" y="0" width="90.86" height="90.86" fill="white">
    <use href="#da"/>
    </mask>
    <circle id="cz" cx="73.15" cy="677.6" r="45.43"/>
    <mask id="gy" x="0" y="0" width="90.86" height="90.86" fill="white">
    <use href="#cz"/>
    </mask>
    <circle id="cy" cx="61.6" cy="847" r="45.43"/>
    <mask id="gx" x="0" y="0" width="90.86" height="90.86" fill="white">
    <use href="#cy"/>
    </mask>
    <circle id="cx" cx="1531.5" cy="737.66" r="45.43"/>
    <mask id="gw" x="0" y="0" width="90.86" height="90.86" fill="white">
    <use href="#cx"/>
    </mask>
    <circle id="cw" cx="667.59" cy="1513.8" r="45.43"/>
    <mask id="gv" x="0" y="0" width="90.86" height="90.86" fill="white">
    <use href="#cw"/>
    </mask>
    <circle id="cv" cx="479.71" cy="1463.8" r="45.43"/>
    <mask id="gu" x="0" y="0" width="90.86" height="90.86" fill="white">
    <use href="#cv"/>
    </mask>
    <circle id="cu" cx="328.79" cy="1368.3" r="45.43"/>
    <mask id="gt" x="0" y="0" width="90.86" height="90.86" fill="white">
    <use href="#cu"/>
    </mask>
    <circle id="ct" cx="180.18" cy="1215.8" r="45.43"/>
    <mask id="gs" x="0" y="0" width="90.86" height="90.86" fill="white">
    <use href="#ct"/>
    </mask>
    <circle id="cs" cx="98.56" cy="1037.2" r="45.43"/>
    <mask id="gr" x="0" y="0" width="90.86" height="90.86" fill="white">
    <use href="#cs"/>
    </mask>
    <circle id="cr" cx="859.32" cy="1524.6" r="45.43"/>
    <mask id="gq" x="0" y="0" width="90.86" height="90.86" fill="white">
    <use href="#cr"/>
    </mask>
    <circle id="cq" cx="1047.2" cy="1490" r="45.43"/>
    <mask id="gp" x="0" y="0" width="90.86" height="90.86" fill="white">
    <use href="#cq"/>
    </mask>
    <circle id="cp" cx="1235.1" cy="1390.6" r="45.43"/>
    <mask id="go" x="0" y="0" width="90.86" height="90.86" fill="white">
    <use href="#cp"/>
    </mask>
    <circle id="cn" cx="1376.8" cy="1245.1" r="45.43"/>
    <mask id="gn" x="0" y="0" width="90.86" height="90.86" fill="white">
    <use href="#cn"/>
    </mask>
    <circle id="cm" cx="1480.7" cy="1086.5" r="45.43"/>
    <mask id="gm" x="0" y="0" width="90.86" height="90.86" fill="white">
    <use href="#cm"/>
    </mask>
    <circle id="cl" cx="1530" cy="917.07" r="45.43"/>
    <mask id="gl" x="0" y="0" width="90.86" height="90.86" fill="white">
    <use href="#cl"/>
    </mask>
    <circle id="ck" cx="739.2" cy="61.6" r="45.43"/>
    <mask id="gj" x="0" y="0" width="90.86" height="90.86" fill="white">
    <use href="#ck"/>
    </mask>
    <circle id="cj" cx="550.55" cy="96.25" r="45.43"/>
    <mask id="gi" x="0" y="0" width="90.86" height="90.86" fill="white">
    <use href="#cj"/>
    </mask>
    <circle id="ci" cx="364.98" cy="195.58" r="45.43"/>
    <mask id="gh" x="0" y="0" width="90.86" height="90.86" fill="white">
    <use href="#ci"/>
    </mask>
    <circle id="ch" cx="121.66" cy="507.43" r="45.43"/>
    <mask id="gg" x="0" y="0" width="90.86" height="90.86" fill="white">
    <use href="#ch"/>
    </mask>
    <ellipse id="cf" cx="560.39" cy="552.38" rx="509.36" ry="509.89"/>
    <mask id="gf" x="0" y="0" width="1018.71" height="1019.788" fill="white">
    <use href="#cf"/>
    </mask>
    <ellipse id="ce" cx="560.39" cy="552.38" rx="526.06" ry="526.6"/>
    <mask id="ge" x="0" y="0" width="1052.128" height="1053.206" fill="white">
    <use href="#ce"/>
    </mask>
    <circle id="cd" cx="887.73" cy="151.46" r="31.801"/>
    <mask id="gc" x="0" y="0" width="63.602" height="63.602" fill="white">
    <use href="#cd"/>
    </mask>
    <circle id="cc" cx="783.17" cy="85.162" r="31.801"/>
    <mask id="gb" x="0" y="0" width="63.602" height="63.602" fill="white">
    <use href="#cc"/>
    </mask>
    <circle id="cb" cx="651.11" cy="50.666" r="31.801"/>
    <mask id="ga" x="0" y="0" width="63.602" height="63.602" fill="white">
    <use href="#cb"/>
    </mask>
    <circle id="ca" cx="1055.4" cy="399.4" r="31.801"/>
    <mask id="fz" x="0" y="0" width="63.602" height="63.602" fill="white">
    <use href="#ca"/>
    </mask>
    <circle id="by" cx="1055.4" cy="399.4" r="31.801"/>
    <mask id="fy" x="0" y="0" width="63.602" height="63.602" fill="white">
    <use href="#by"/>
    </mask>
    <circle id="bx" cx="992.3" cy="259.26" r="31.801"/>
    <mask id="fx" x="0" y="0" width="63.602" height="63.602" fill="white">
    <use href="#bx"/>
    </mask>
    <circle id="bw" cx="155.23" cy="237.7" r="31.801"/>
    <mask id="fw" x="0" y="0" width="63.602" height="63.602" fill="white">
    <use href="#bw"/>
    </mask>
    <circle id="bv" cx="51.205" cy="474.32" r="31.801"/>
    <mask id="fu" x="0" y="0" width="63.602" height="63.602" fill="white">
    <use href="#bv"/>
    </mask>
    <circle id="bu" cx="43.12" cy="592.9" r="31.801"/>
    <mask id="ft" x="0" y="0" width="63.602" height="63.602" fill="white">
    <use href="#bu"/>
    </mask>
    <circle id="bt" cx="1072.1" cy="516.36" r="31.801"/>
    <mask id="fs" x="0" y="0" width="63.602" height="63.602" fill="white">
    <use href="#bt"/>
    </mask>
    <circle id="bs" cx="467.31" cy="1059.7" r="31.801"/>
    <mask id="fr" x="0" y="0" width="63.602" height="63.602" fill="white">
    <use href="#bs"/>
    </mask>
    <circle id="br" cx="335.8" cy="1024.6" r="31.801"/>
    <mask id="fq" x="0" y="0" width="63.602" height="63.602" fill="white">
    <use href="#br"/>
    </mask>
    <circle id="bq" cx="230.15" cy="957.8" r="31.801"/>
    <mask id="fp" x="0" y="0" width="63.602" height="63.602" fill="white">
    <use href="#bq"/>
    </mask>
    <circle id="bo" cx="126.13" cy="851.08" r="31.801"/>
    <mask id="fo" x="0" y="0" width="63.602" height="63.602" fill="white">
    <use href="#bo"/>
    </mask>
    <circle id="bn" cx="68.992" cy="726.03" r="31.801"/>
    <mask id="fn" x="0" y="0" width="63.602" height="63.602" fill="white">
    <use href="#bn"/>
    </mask>
    <circle id="bm" cx="601.52" cy="1067.2" r="31.801"/>
    <mask id="fm" x="0" y="0" width="63.602" height="63.602" fill="white">
    <use href="#bm"/>
    </mask>
    <circle id="bl" cx="733.04" cy="1043" r="31.801"/>
    <mask id="fk" x="0" y="0" width="63.602" height="63.602" fill="white">
    <use href="#bl"/>
    </mask>
    <circle id="bk" cx="864.56" cy="973.43" r="31.801"/>
    <mask id="fj" x="0" y="0" width="63.602" height="63.602" fill="white">
    <use href="#bk"/>
    </mask>
    <circle id="bj" cx="963.73" cy="871.56" r="31.801"/>
    <mask id="fi" x="0" y="0" width="63.602" height="63.602" fill="white">
    <use href="#bj"/>
    </mask>
    <circle id="bi" cx="1036.5" cy="760.53" r="31.801"/>
    <mask id="fh" x="0" y="0" width="63.602" height="63.602" fill="white">
    <use href="#bi"/>
    </mask>
    <circle id="bh" cx="1071" cy="641.95" r="31.801"/>
    <mask id="fg" x="0" y="0" width="63.602" height="63.602" fill="white">
    <use href="#bh"/>
    </mask>
    <circle id="bg" cx="517.44" cy="43.12" r="31.801"/>
    <mask id="ff" x="0" y="0" width="63.602" height="63.602" fill="white">
    <use href="#bg"/>
    </mask>
    <circle id="bf" cx="385.38" cy="67.375" r="31.801"/>
    <mask id="fe" x="0" y="0" width="63.602" height="63.602" fill="white">
    <use href="#bf"/>
    </mask>
    <circle id="be" cx="255.49" cy="136.91" r="31.801"/>
    <mask id="fd" x="0" y="0" width="63.602" height="63.602" fill="white">
    <use href="#be"/>
    </mask>
    <circle id="bd" cx="85.162" cy="355.2" r="31.801"/>
    <mask id="fc" x="0" y="0" width="63.602" height="63.602" fill="white">
    <use href="#bd"/>
    </mask>
    <ellipse id="bb" cx="392.27" cy="386.66" rx="356.55" ry="356.93"/>
    <mask id="fb" x="0" y="0" width="713.097" height="713.8516" fill="white">
    <use href="#bb"/>
    </mask>
    <ellipse id="ba" cx="392.27" cy="386.66" rx="368.24" ry="368.62"/>
    <mask id="fa" x="0" y="0" width="736.4896" height="737.2442" fill="white">
    <use href="#ba"/>
    </mask>
    <circle id="az" cx="621.41" cy="106.02" r="22.261"/>
    <mask id="ey" x="0" y="0" width="44.5214" height="44.5214" fill="white">
    <use href="#az"/>
    </mask>
    <circle id="ay" cx="548.22" cy="59.613" r="22.261"/>
    <mask id="ex" x="0" y="0" width="44.5214" height="44.5214" fill="white">
    <use href="#ay"/>
    </mask>
    <circle id="ax" cx="455.78" cy="35.466" r="22.261"/>
    <mask id="ew" x="0" y="0" width="44.5214" height="44.5214" fill="white">
    <use href="#ax"/>
    </mask>
    <circle id="av" cx="738.75" cy="279.58" r="22.261"/>
    <mask id="ev" x="0" y="0" width="44.5214" height="44.5214" fill="white">
    <use href="#av"/>
    </mask>
    <circle id="au" cx="738.75" cy="279.58" r="22.261"/>
    <mask id="eu" x="0" y="0" width="44.5214" height="44.5214" fill="white">
    <use href="#au"/>
    </mask>
    <circle id="at" cx="694.61" cy="181.48" r="22.261"/>
    <mask id="et" x="0" y="0" width="44.5214" height="44.5214" fill="white">
    <use href="#at"/>
    </mask>
    <circle id="as" cx="108.66" cy="166.39" r="22.261"/>
    <mask id="er" x="0" y="0" width="44.5214" height="44.5214" fill="white">
    <use href="#as"/>
    </mask>
    <circle id="ar" cx="35.844" cy="332.02" r="22.261"/>
    <mask id="eq" x="0" y="0" width="44.5214" height="44.5214" fill="white">
    <use href="#ar"/>
    </mask>
    <circle id="aq" cx="30.184" cy="415.03" r="22.261"/>
    <mask id="ep" x="0" y="0" width="44.5214" height="44.5214" fill="white">
    <use href="#aq"/>
    </mask>
    <circle id="ap" cx="750.45" cy="361.45" r="22.261"/>
    <mask id="eo" x="0" y="0" width="44.5214" height="44.5214" fill="white">
    <use href="#ap"/>
    </mask>
    <circle id="ao" cx="327.12" cy="741.77" r="22.261"/>
    <mask id="en" x="0" y="0" width="44.5214" height="44.5214" fill="white">
    <use href="#ao"/>
    </mask>
    <circle id="an" cx="235.06" cy="717.25" r="22.261"/>
    <mask id="em" x="0" y="0" width="44.5214" height="44.5214" fill="white">
    <use href="#an"/>
    </mask>
    <circle id="am" cx="161.11" cy="670.46" r="22.261"/>
    <mask id="el" x="0" y="0" width="44.5214" height="44.5214" fill="white">
    <use href="#am"/>
    </mask>
    <circle id="al" cx="88.288" cy="595.76" r="22.261"/>
    <mask id="ek" x="0" y="0" width="44.5214" height="44.5214" fill="white">
    <use href="#al"/>
    </mask>
    <circle id="ak" cx="48.294" cy="508.22" r="22.261"/>
    <mask id="ej" x="0" y="0" width="44.5214" height="44.5214" fill="white">
    <use href="#ak"/>
    </mask>
    <circle id="aj" cx="421.07" cy="747.05" r="22.261"/>
    <mask id="ei" x="0" y="0" width="44.5214" height="44.5214" fill="white">
    <use href="#aj"/>
    </mask>
    <circle id="ah" cx="513.13" cy="730.08" r="22.261"/>
    <mask id="eh" x="0" y="0" width="44.5214" height="44.5214" fill="white">
    <use href="#ah"/>
    </mask>
    <circle id="ag" cx="605.19" cy="681.4" r="22.261"/>
    <mask id="eg" x="0" y="0" width="44.5214" height="44.5214" fill="white">
    <use href="#ag"/>
    </mask>
    <circle id="af" cx="674.61" cy="610.09" r="22.261"/>
    <mask id="ef" x="0" y="0" width="44.5214" height="44.5214" fill="white">
    <use href="#af"/>
    </mask>
    <circle id="ae" cx="725.55" cy="532.37" r="22.261"/>
    <mask id="ee" x="0" y="0" width="44.5214" height="44.5214" fill="white">
    <use href="#ae"/>
    </mask>
    <circle id="ad" cx="749.7" cy="449.36" r="22.261"/>
    <mask id="ed" x="0" y="0" width="44.5214" height="44.5214" fill="white">
    <use href="#ad"/>
    </mask>
    <circle id="ac" cx="362.21" cy="30.184" r="22.261"/>
    <mask id="ec" x="0" y="0" width="44.5214" height="44.5214" fill="white">
    <use href="#ac"/>
    </mask>
    <circle id="ab" cx="269.77" cy="47.162" r="22.261"/>
    <mask id="eb" x="0" y="0" width="44.5214" height="44.5214" fill="white">
    <use href="#ab"/>
    </mask>
    <circle id="z" cx="178.84" cy="95.834" r="22.261"/>
    <mask id="ea" x="0" y="0" width="44.5214" height="44.5214" fill="white">
    <use href="#z"/>
    </mask>
    <circle id="y" cx="59.613" cy="248.64" r="22.261"/>
    <mask id="dz" x="0" y="0" width="44.5214" height="44.5214" fill="white">
    <use href="#y"/>
    </mask>
    </defs>
    <g fill="none" fill-rule="evenodd">
    <g transform="translate(0 -413)">
    <g transform="translate(-180 413)">
    <circle id="Oval-Copy-66" transform="translate(1137.4 1131.9) rotate(90) translate(-1137.4 -1131.9)" cx="1137.4" cy="1131.9" r="1061.5" fill="#000" opacity=".5"/>
    <g id="Group-7-Copy-2" opacity=".6">
    <ellipse id="Oval" transform="translate(1143.7 1126.3) rotate(-90) translate(-1143.7 -1126.3)" cx="1143.7" cy="1126.3" rx="1052" ry="1052.2" stroke="url(#a)" stroke-width="11"/>
    <use id="Oval" transform="translate(1143.6 1127.3) rotate(-90) translate(-1143.6 -1127.3)" mask="url(#dw)" stroke="url(#a)" stroke-dasharray="2.2,24.2" stroke-width="35.2" href="#ai"/>
    <use id="Oval" transform="translate(1143.6 1127.3) rotate(-90) translate(-1143.6 -1127.3)" mask="url(#dl)" stroke="url(#a)" stroke-dasharray="3.3,11" stroke-width="6.6" href="#p"/>
    <g id="Oval" transform="translate(1329.3 103.09) rotate(-90) translate(-1329.3 -103.09)" stroke-linejoin="square" stroke-width="11">
    <ellipse cx="1329.3" cy="103.09" rx="82.385" ry="82.363" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="1329.3" cy="103.09" rx="82.385" ry="82.363" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <g id="Oval-Copy-61" transform="translate(1598.2 173.39) rotate(-90) translate(-1598.2 -173.39)" stroke-linejoin="square" stroke-width="11">
    <ellipse cx="1598.2" cy="173.39" rx="82.385" ry="82.363" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="1598.2" cy="173.39" rx="82.385" ry="82.363" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <g id="Oval-Copy-65" transform="translate(1811.9 309.26) rotate(-90) translate(-1811.9 -309.26)" stroke-linejoin="square" stroke-width="11">
    <ellipse cx="1811.9" cy="309.26" rx="82.385" ry="82.363" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="1811.9" cy="309.26" rx="82.385" ry="82.363" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#gk)" stroke="url(#a)" stroke-dasharray="2.2" stroke-width="4.4" href="#co"/>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#gd)" stroke="url(#a)" stroke-dasharray="2.2" stroke-width="4.4" href="#cg"/>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#fv)" stroke="url(#a)" stroke-dasharray="2.2" stroke-width="4.4" href="#bz"/>
    <g id="Oval-Copy-66" transform="translate(2025.6 528.73) rotate(-90) translate(-2025.6 -528.73)" stroke-linejoin="square" stroke-width="11">
    <ellipse cx="2025.6" cy="528.73" rx="82.385" ry="82.363" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="2025.6" cy="528.73" rx="82.385" ry="82.363" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#fl)" stroke="url(#a)" stroke-dasharray="2.2" stroke-width="4.4" href="#bp"/>
    <g id="Oval-Copy-67" transform="translate(2153.8 814.71) rotate(-90) translate(-2153.8 -814.71)" stroke-linejoin="square" stroke-width="11">
    <ellipse cx="2153.8" cy="814.71" rx="82.385" ry="82.363" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="2153.8" cy="814.71" rx="82.385" ry="82.363" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#ez)" stroke="url(#a)" stroke-dasharray="2.2" stroke-width="4.4" href="#bc"/>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#es)" stroke="url(#a)" stroke-dasharray="2.2" stroke-width="4.4" href="#aw"/>
    <g id="Oval-Copy-56" transform="translate(1055.8 87.885) rotate(-90) translate(-1055.8 -87.885)" stroke-linejoin="square" stroke-width="11">
    <ellipse cx="1055.8" cy="87.885" rx="82.385" ry="82.363" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="1055.8" cy="87.885" rx="82.385" ry="82.363" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <g id="Oval-Copy-58" transform="translate(786.97 137.29) rotate(-90) translate(-786.97 -137.29)" stroke-linejoin="square" stroke-width="11">
    <ellipse cx="786.97" cy="137.29" rx="82.385" ry="82.363" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="786.97" cy="137.29" rx="82.385" ry="82.363" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <g id="Oval-Copy-63" transform="translate(521.01 278.86) rotate(-90) translate(-521.01 -278.86)" stroke-linejoin="square" stroke-width="11">
    <ellipse cx="521.01" cy="278.86" rx="82.385" ry="82.363" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="521.01" cy="278.86" rx="82.385" ry="82.363" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <g id="Oval-Copy-69" transform="translate(316.78 485.03) rotate(-90) translate(-316.78 -485.03)" stroke-linejoin="square" stroke-width="11">
    <ellipse cx="316.78" cy="485.03" rx="82.385" ry="82.363" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="316.78" cy="485.03" rx="82.385" ry="82.363" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#dy)" stroke="url(#a)" stroke-dasharray="2.2" stroke-width="4.4" href="#aa"/>
    <g id="Oval-Copy-70" transform="translate(173.35 725.41) rotate(-90) translate(-173.35 -725.41)" stroke-linejoin="square" stroke-width="11">
    <ellipse cx="173.35" cy="725.41" rx="82.385" ry="82.363" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="173.35" cy="725.41" rx="82.385" ry="82.363" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <g id="Oval-Copy-71" transform="translate(104.96 967.68) rotate(-90) translate(-104.96 -967.68)" stroke-linejoin="square" stroke-width="11">
    <ellipse cx="104.96" cy="967.68" rx="82.385" ry="82.363" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="104.96" cy="967.68" rx="82.385" ry="82.363" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <g id="Oval" transform="translate(953.2 2162.9) rotate(90) translate(-953.2 -2162.9)" stroke-linejoin="square" stroke-width="11">
    <ellipse cx="953.2" cy="2162.9" rx="82.385" ry="82.363" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="953.2" cy="2162.9" rx="82.385" ry="82.363" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#dx)" stroke="url(#a)" stroke-dasharray="2.2" stroke-width="4.4" href="#x"/>
    <g id="Oval-Copy-61" transform="translate(685.33 2090.7) rotate(90) translate(-685.33 -2090.7)" stroke-linejoin="square" stroke-width="11">
    <ellipse cx="685.33" cy="2090.7" rx="82.385" ry="82.363" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="685.33" cy="2090.7" rx="82.385" ry="82.363" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#dv)" stroke="url(#a)" stroke-dasharray="2.2" stroke-width="4.4" href="#w"/>
    <g id="Oval-Copy-65" transform="translate(469.71 1954.8) rotate(90) translate(-469.71 -1954.8)" stroke-linejoin="square" stroke-width="11">
    <ellipse cx="469.71" cy="1954.8" rx="82.385" ry="82.363" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="469.71" cy="1954.8" rx="82.385" ry="82.363" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#du)" stroke="url(#a)" stroke-dasharray="2.2" stroke-width="4.4" href="#v"/>
    <g id="Oval-Copy-66" transform="translate(257.89 1737.3) rotate(90) translate(-257.89 -1737.3)" stroke-linejoin="square" stroke-width="11">
    <ellipse cx="257.89" cy="1737.3" rx="82.385" ry="82.363" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="257.89" cy="1737.3" rx="82.385" ry="82.363" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#dt)" stroke="url(#a)" stroke-dasharray="2.2" stroke-width="4.4" href="#u"/>
    <g id="Oval-Copy-67" transform="translate(141.06 1481.7) rotate(90) translate(-141.06 -1481.7)" stroke-linejoin="square" stroke-width="11">
    <ellipse cx="141.06" cy="1481.7" rx="82.385" ry="82.363" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="141.06" cy="1481.7" rx="82.385" ry="82.363" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#ds)" stroke="url(#a)" stroke-dasharray="2.2" stroke-width="4.4" href="#t"/>
    <g id="Oval-Copy-56" transform="translate(1227.7 2178.1) rotate(90) translate(-1227.7 -2178.1)" stroke-linejoin="square" stroke-width="11">
    <ellipse cx="1227.7" cy="2178.1" rx="82.385" ry="82.363" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="1227.7" cy="2178.1" rx="82.385" ry="82.363" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#dr)" stroke="url(#a)" stroke-dasharray="2.2" stroke-width="4.4" href="#s"/>
    <g id="Oval-Copy-58" transform="translate(1496.5 2128.7) rotate(90) translate(-1496.5 -2128.7)" stroke-linejoin="square" stroke-width="11">
    <ellipse cx="1496.5" cy="2128.7" rx="82.385" ry="82.363" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="1496.5" cy="2128.7" rx="82.385" ry="82.363" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#dq)" stroke="url(#a)" stroke-dasharray="2.2" stroke-width="4.4" href="#r"/>
    <g id="Oval-Copy-63" transform="translate(1764.4 1987.1) rotate(90) translate(-1764.4 -1987.1)" stroke-linejoin="square" stroke-width="11">
    <ellipse cx="1764.4" cy="1987.1" rx="82.385" ry="82.363" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="1764.4" cy="1987.1" rx="82.385" ry="82.363" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#dp)" stroke="url(#a)" stroke-dasharray="2.2" stroke-width="4.4" href="#q"/>
    <g id="Oval-Copy-69" transform="translate(1966.7 1779.1) rotate(90) translate(-1966.7 -1779.1)" stroke-linejoin="square" stroke-width="11">
    <ellipse cx="1966.7" cy="1779.1" rx="82.385" ry="82.363" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="1966.7" cy="1779.1" rx="82.385" ry="82.363" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#do)" stroke="url(#a)" stroke-dasharray="2.2" stroke-width="4.4" href="#o"/>
    <g id="Oval-Copy-70" transform="translate(2115.8 1552) rotate(90) translate(-2115.8 -1552)" stroke-linejoin="square" stroke-width="11">
    <ellipse cx="2115.8" cy="1552" rx="82.385" ry="82.363" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="2115.8" cy="1552" rx="82.385" ry="82.363" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#dn)" stroke="url(#a)" stroke-dasharray="2.2" stroke-width="4.4" href="#n"/>
    <g id="Oval-Copy-71" transform="translate(2186.1 1309.7) rotate(90) translate(-2186.1 -1309.7)" stroke-linejoin="square" stroke-width="11">
    <ellipse cx="2186.1" cy="1309.7" rx="82.385" ry="82.363" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="2186.1" cy="1309.7" rx="82.385" ry="82.363" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#dm)" stroke="url(#a)" stroke-dasharray="2.2" stroke-width="4.4" href="#m"/>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#dk)" stroke="url(#a)" stroke-dasharray="2.2" stroke-width="4.4" href="#l"/>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#dj)" stroke="url(#a)" stroke-dasharray="2.2" stroke-width="4.4" href="#k"/>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#di)" stroke="url(#a)" stroke-dasharray="2.2" stroke-width="4.4" href="#j"/>
    </g>
    <g id="Group-7-Copy-2" transform="translate(341 339.9)" opacity=".3">
    <ellipse id="Oval" transform="translate(800.56 788.44) rotate(-90) translate(-800.56 -788.44)" cx="800.56" cy="788.44" rx="736.38" ry="736.52" stroke="url(#a)" stroke-width="7.7"/>
    <use id="Oval" transform="translate(800.55 789.11) rotate(-90) translate(-800.55 -789.11)" mask="url(#dh)" stroke="url(#a)" stroke-dasharray="2.2,24.2" stroke-width="28.6" href="#i"/>
    <use id="Oval" transform="translate(800.55 789.11) rotate(-90) translate(-800.55 -789.11)" mask="url(#dg)" stroke="url(#a)" stroke-dasharray="2.309999895095825,7.700000000000001" stroke-width="4.62" href="#h"/>
    <g id="Oval" transform="translate(930.54 72.16) rotate(-90) translate(-930.54 -72.16)" stroke-linejoin="square" stroke-width="7.7">
    <ellipse cx="930.54" cy="72.16" rx="57.669" ry="57.654" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="930.54" cy="72.16" rx="57.669" ry="57.654" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <g id="Oval-Copy-61" transform="translate(1118.7 121.38) rotate(-90) translate(-1118.7 -121.38)" stroke-linejoin="square" stroke-width="7.7">
    <ellipse cx="1118.7" cy="121.38" rx="57.669" ry="57.654" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="1118.7" cy="121.38" rx="57.669" ry="57.654" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <g id="Oval-Copy-65" transform="translate(1268.3 216.48) rotate(-90) translate(-1268.3 -216.48)" stroke-linejoin="square" stroke-width="7.7">
    <ellipse cx="1268.3" cy="216.48" rx="57.669" ry="57.654" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="1268.3" cy="216.48" rx="57.669" ry="57.654" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#df)" stroke="url(#a)" stroke-dasharray="1.539999973773956" stroke-width="3.08" href="#g"/>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#de)" stroke="url(#a)" stroke-dasharray="1.539999973773956" stroke-width="3.08" href="#f"/>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#dd)" stroke="url(#a)" stroke-dasharray="1.539999973773956" stroke-width="3.08" href="#e"/>
    <g id="Oval-Copy-66" transform="translate(1417.9 370.11) rotate(-90) translate(-1417.9 -370.11)" stroke-linejoin="square" stroke-width="7.7">
    <ellipse cx="1417.9" cy="370.11" rx="57.669" ry="57.654" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="1417.9" cy="370.11" rx="57.669" ry="57.654" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#dc)" stroke="url(#a)" stroke-dasharray="1.539999973773956" stroke-width="3.08" href="#d"/>
    <g id="Oval-Copy-67" transform="translate(1507.7 570.3) rotate(-90) translate(-1507.7 -570.3)" stroke-linejoin="square" stroke-width="7.7">
    <ellipse cx="1507.7" cy="570.3" rx="57.669" ry="57.654" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="1507.7" cy="570.3" rx="57.669" ry="57.654" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#db)" stroke="url(#a)" stroke-dasharray="1.539999973773956" stroke-width="3.08" href="#c"/>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#ha)" stroke="url(#a)" stroke-dasharray="1.539999973773956" stroke-width="3.08" href="#b"/>
    <g id="Oval-Copy-56" transform="translate(739.05 61.519) rotate(-90) translate(-739.05 -61.519)" stroke-linejoin="square" stroke-width="7.7">
    <ellipse cx="739.05" cy="61.519" rx="57.669" ry="57.654" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="739.05" cy="61.519" rx="57.669" ry="57.654" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <g id="Oval-Copy-58" transform="translate(550.88 96.103) rotate(-90) translate(-550.88 -96.103)" stroke-linejoin="square" stroke-width="7.7">
    <ellipse cx="550.88" cy="96.103" rx="57.669" ry="57.654" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="550.88" cy="96.103" rx="57.669" ry="57.654" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <g id="Oval-Copy-63" transform="translate(364.7 195.2) rotate(-90) translate(-364.7 -195.2)" stroke-linejoin="square" stroke-width="7.7">
    <ellipse cx="364.7" cy="195.2" rx="57.669" ry="57.654" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="364.7" cy="195.2" rx="57.669" ry="57.654" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <g id="Oval-Copy-69" transform="translate(221.75 339.52) rotate(-90) translate(-221.75 -339.52)" stroke-linejoin="square" stroke-width="7.7">
    <ellipse cx="221.75" cy="339.52" rx="57.669" ry="57.654" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="221.75" cy="339.52" rx="57.669" ry="57.654" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#gz)" stroke="url(#a)" stroke-dasharray="1.539999973773956" stroke-width="3.08" href="#da"/>
    <g id="Oval-Copy-70" transform="translate(121.35 507.78) rotate(-90) translate(-121.35 -507.78)" stroke-linejoin="square" stroke-width="7.7">
    <ellipse cx="121.35" cy="507.78" rx="57.669" ry="57.654" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="121.35" cy="507.78" rx="57.669" ry="57.654" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <g id="Oval-Copy-71" transform="translate(73.473 677.38) rotate(-90) translate(-73.473 -677.38)" stroke-linejoin="square" stroke-width="7.7">
    <ellipse cx="73.473" cy="677.38" rx="57.669" ry="57.654" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="73.473" cy="677.38" rx="57.669" ry="57.654" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#gy)" stroke="url(#a)" stroke-dasharray="1.539999973773956" stroke-width="3.08" href="#cz"/>
    <g id="Oval-Copy-72" transform="translate(61.504 846.97) rotate(-90) translate(-61.504 -846.97)" stroke-linejoin="square" stroke-width="7.7">
    <ellipse cx="61.504" cy="846.97" rx="57.669" ry="57.654" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="61.504" cy="846.97" rx="57.669" ry="57.654" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#gx)" stroke="url(#a)" stroke-dasharray="1.539999973773956" stroke-width="3.08" href="#cy"/>
    <g id="Oval-Copy-68" transform="translate(1531.6 737.9) rotate(-90) translate(-1531.6 -737.9)" stroke-linejoin="square" stroke-width="7.7">
    <ellipse cx="1531.6" cy="737.9" rx="57.669" ry="57.654" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="1531.6" cy="737.9" rx="57.669" ry="57.654" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#gw)" stroke="url(#a)" stroke-dasharray="1.539999973773956" stroke-width="3.08" href="#cx"/>
    <g id="Oval" transform="translate(667.24 1514) rotate(90) translate(-667.24 -1514)" stroke-linejoin="square" stroke-width="7.7">
    <ellipse cx="667.24" cy="1514" rx="57.669" ry="57.654" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="667.24" cy="1514" rx="57.669" ry="57.654" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#gv)" stroke="url(#a)" stroke-dasharray="1.539999973773956" stroke-width="3.08" href="#cw"/>
    <g id="Oval-Copy-61" transform="translate(479.73 1463.5) rotate(90) translate(-479.73 -1463.5)" stroke-linejoin="square" stroke-width="7.7">
    <ellipse cx="479.73" cy="1463.5" rx="57.669" ry="57.654" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="479.73" cy="1463.5" rx="57.669" ry="57.654" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#gu)" stroke="url(#a)" stroke-dasharray="1.539999973773956" stroke-width="3.08" href="#cv"/>
    <g id="Oval-Copy-65" transform="translate(328.8 1368.4) rotate(90) translate(-328.8 -1368.4)" stroke-linejoin="square" stroke-width="7.7">
    <ellipse cx="328.8" cy="1368.4" rx="57.669" ry="57.654" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="328.8" cy="1368.4" rx="57.669" ry="57.654" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#gt)" stroke="url(#a)" stroke-dasharray="1.539999973773956" stroke-width="3.08" href="#cu"/>
    <g id="Oval-Copy-66" transform="translate(180.52 1216.1) rotate(90) translate(-180.52 -1216.1)" stroke-linejoin="square" stroke-width="7.7">
    <ellipse cx="180.52" cy="1216.1" rx="57.669" ry="57.654" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="180.52" cy="1216.1" rx="57.669" ry="57.654" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#gs)" stroke="url(#a)" stroke-dasharray="1.539999973773956" stroke-width="3.08" href="#ct"/>
    <g id="Oval-Copy-67" transform="translate(98.739 1037.2) rotate(90) translate(-98.739 -1037.2)" stroke-linejoin="square" stroke-width="7.7">
    <ellipse cx="98.739" cy="1037.2" rx="57.669" ry="57.654" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="98.739" cy="1037.2" rx="57.669" ry="57.654" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#gr)" stroke="url(#a)" stroke-dasharray="1.539999973773956" stroke-width="3.08" href="#cs"/>
    <g id="Oval-Copy-56" transform="translate(859.4 1524.7) rotate(90) translate(-859.4 -1524.7)" stroke-linejoin="square" stroke-width="7.7">
    <ellipse cx="859.4" cy="1524.7" rx="57.669" ry="57.654" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="859.4" cy="1524.7" rx="57.669" ry="57.654" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#gq)" stroke="url(#a)" stroke-dasharray="1.539999973773956" stroke-width="3.08" href="#cr"/>
    <g id="Oval-Copy-58" transform="translate(1047.6 1490.1) rotate(90) translate(-1047.6 -1490.1)" stroke-linejoin="square" stroke-width="7.7">
    <ellipse cx="1047.6" cy="1490.1" rx="57.669" ry="57.654" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="1047.6" cy="1490.1" rx="57.669" ry="57.654" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#gp)" stroke="url(#a)" stroke-dasharray="1.539999973773956" stroke-width="3.08" href="#cq"/>
    <g id="Oval-Copy-63" transform="translate(1235.1 1391) rotate(90) translate(-1235.1 -1391)" stroke-linejoin="square" stroke-width="7.7">
    <ellipse cx="1235.1" cy="1391" rx="57.669" ry="57.654" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="1235.1" cy="1391" rx="57.669" ry="57.654" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#go)" stroke="url(#a)" stroke-dasharray="1.539999973773956" stroke-width="3.08" href="#cp"/>
    <g id="Oval-Copy-69" transform="translate(1376.7 1245.3) rotate(90) translate(-1376.7 -1245.3)" stroke-linejoin="square" stroke-width="7.7">
    <ellipse cx="1376.7" cy="1245.3" rx="57.669" ry="57.654" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="1376.7" cy="1245.3" rx="57.669" ry="57.654" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#gn)" stroke="url(#a)" stroke-dasharray="1.539999973773956" stroke-width="3.08" href="#cn"/>
    <g id="Oval-Copy-70" transform="translate(1481.1 1086.4) rotate(90) translate(-1481.1 -1086.4)" stroke-linejoin="square" stroke-width="7.7">
    <ellipse cx="1481.1" cy="1086.4" rx="57.669" ry="57.654" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="1481.1" cy="1086.4" rx="57.669" ry="57.654" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#gm)" stroke="url(#a)" stroke-dasharray="1.539999973773956" stroke-width="3.08" href="#cm"/>
    <g id="Oval-Copy-71" transform="translate(1530.3 916.8) rotate(90) translate(-1530.3 -916.8)" stroke-linejoin="square" stroke-width="7.7">
    <ellipse cx="1530.3" cy="916.8" rx="57.669" ry="57.654" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="1530.3" cy="916.8" rx="57.669" ry="57.654" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#gl)" stroke="url(#a)" stroke-dasharray="1.539999973773956" stroke-width="3.08" href="#cl"/>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#gj)" stroke="url(#a)" stroke-dasharray="1.539999973773956" stroke-width="3.08" href="#ck"/>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#gi)" stroke="url(#a)" stroke-dasharray="1.539999973773956" stroke-width="3.08" href="#cj"/>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#gh)" stroke="url(#a)" stroke-dasharray="1.539999973773956" stroke-width="3.08" href="#ci"/>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#gg)" stroke="url(#a)" stroke-dasharray="1.539999973773956" stroke-width="3.08" href="#ch"/>
    </g>
    <g id="hi" transform="translate(579.7 577.5)" opacity=".2">
    <ellipse id="Oval" transform="translate(560.4 551.91) rotate(-90) translate(-560.4 -551.91)" cx="560.4" cy="551.91" rx="515.46" ry="515.56" stroke="url(#a)" stroke-width="5.39"/>
    <use id="Oval" transform="translate(560.39 552.38) rotate(-90) translate(-560.39 -552.38)" mask="url(#gf)" stroke="url(#a)" stroke-dasharray="1.539999973773956,16.9399995803833" stroke-width="20.02" href="#cf"/>
    <use id="Oval" transform="translate(560.39 552.38) rotate(-90) translate(-560.39 -552.38)" mask="url(#ge)" stroke="url(#a)" stroke-dasharray="1.616999900341034,5.390000104904175" stroke-width="3.234" href="#ce"/>
    <g id="Oval" transform="translate(651.38 50.512) rotate(-90) translate(-651.38 -50.512)" stroke-linejoin="square" stroke-width="5.39">
    <ellipse cx="651.38" cy="50.512" rx="40.369" ry="40.358" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="651.38" cy="50.512" rx="40.369" ry="40.358" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <g id="Oval-Copy-61" transform="translate(783.1 84.963) rotate(-90) translate(-783.1 -84.963)" stroke-linejoin="square" stroke-width="5.39">
    <ellipse cx="783.1" cy="84.963" rx="40.369" ry="40.358" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="783.1" cy="84.963" rx="40.369" ry="40.358" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <g id="Oval-Copy-65" transform="translate(887.82 151.54) rotate(-90) translate(-887.82 -151.54)" stroke-linejoin="square" stroke-width="5.39">
    <ellipse cx="887.82" cy="151.54" rx="40.369" ry="40.358" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="887.82" cy="151.54" rx="40.369" ry="40.358" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#gc)" stroke="url(#a)" stroke-dasharray="1.077999955415726" stroke-width="2.156" href="#cd"/>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#gb)" stroke="url(#a)" stroke-dasharray="1.077999955415726" stroke-width="2.156" href="#cc"/>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#ga)" stroke="url(#a)" stroke-dasharray="1.077999955415726" stroke-width="2.156" href="#cb"/>
    <g id="Oval-Copy-66" transform="translate(992.55 259.08) rotate(-90) translate(-992.55 -259.08)" stroke-linejoin="square" stroke-width="5.39">
    <ellipse cx="992.55" cy="259.08" rx="40.369" ry="40.358" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="992.55" cy="259.08" rx="40.369" ry="40.358" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#fz)" stroke="url(#a)" stroke-dasharray="1.077999955415726" stroke-width="2.156" href="#ca"/>
    <g id="Oval-Copy-67" transform="translate(1055.4 399.21) rotate(-90) translate(-1055.4 -399.21)" stroke-linejoin="square" stroke-width="5.39">
    <ellipse cx="1055.4" cy="399.21" rx="40.369" ry="40.358" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="1055.4" cy="399.21" rx="40.369" ry="40.358" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#fy)" stroke="url(#a)" stroke-dasharray="1.077999955415726" stroke-width="2.156" href="#by"/>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#fx)" stroke="url(#a)" stroke-dasharray="1.077999955415726" stroke-width="2.156" href="#bx"/>
    <g id="Oval-Copy-56" transform="translate(517.34 43.064) rotate(-90) translate(-517.34 -43.064)" stroke-linejoin="square" stroke-width="5.39">
    <ellipse cx="517.34" cy="43.064" rx="40.369" ry="40.358" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="517.34" cy="43.064" rx="40.369" ry="40.358" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <g id="Oval-Copy-58" transform="translate(385.62 67.272) rotate(-90) translate(-385.62 -67.272)" stroke-linejoin="square" stroke-width="5.39">
    <ellipse cx="385.62" cy="67.272" rx="40.369" ry="40.358" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="385.62" cy="67.272" rx="40.369" ry="40.358" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <g id="Oval-Copy-63" transform="translate(255.29 136.64) rotate(-90) translate(-255.29 -136.64)" stroke-linejoin="square" stroke-width="5.39">
    <ellipse cx="255.29" cy="136.64" rx="40.369" ry="40.358" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="255.29" cy="136.64" rx="40.369" ry="40.358" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <g id="Oval-Copy-69" transform="translate(155.22 237.66) rotate(-90) translate(-155.22 -237.66)" stroke-linejoin="square" stroke-width="5.39">
    <ellipse cx="155.22" cy="237.66" rx="40.369" ry="40.358" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="155.22" cy="237.66" rx="40.369" ry="40.358" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#fw)" stroke="url(#a)" stroke-dasharray="1.077999955415726" stroke-width="2.156" href="#bw"/>
    <g id="Oval-Copy-70" transform="translate(84.943 355.45) rotate(-90) translate(-84.943 -355.45)" stroke-linejoin="square" stroke-width="5.39">
    <ellipse cx="84.943" cy="355.45" rx="40.369" ry="40.358" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="84.943" cy="355.45" rx="40.369" ry="40.358" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <g id="Oval-Copy-71" transform="translate(51.431 474.16) rotate(-90) translate(-51.431 -474.16)" stroke-linejoin="square" stroke-width="5.39">
    <ellipse cx="51.431" cy="474.16" rx="40.369" ry="40.358" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="51.431" cy="474.16" rx="40.369" ry="40.358" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#fu)" stroke="url(#a)" stroke-dasharray="1.077999955415726" stroke-width="2.156" href="#bv"/>
    <g id="hm" transform="translate(43.053 592.88) rotate(-90) translate(-43.053 -592.88)" stroke-linejoin="square" stroke-width="5.39">
    <ellipse cx="43.053" cy="592.88" rx="40.369" ry="40.358" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="43.053" cy="592.88" rx="40.369" ry="40.358" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#ft)" stroke="url(#a)" stroke-dasharray="1.077999955415726" stroke-width="2.156" href="#bu"/>
    <g id="hd" transform="translate(1072.1 516.53) rotate(-90) translate(-1072.1 -516.53)" stroke-linejoin="square" stroke-width="5.39">
    <ellipse cx="1072.1" cy="516.53" rx="40.369" ry="40.358" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="1072.1" cy="516.53" rx="40.369" ry="40.358" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#fs)" stroke="url(#a)" stroke-dasharray="1.077999955415726" stroke-width="2.156" href="#bt"/>
    <g id="Oval" transform="translate(467.07 1059.8) rotate(90) translate(-467.07 -1059.8)" stroke-linejoin="square" stroke-width="5.39">
    <ellipse cx="467.07" cy="1059.8" rx="40.369" ry="40.358" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="467.07" cy="1059.8" rx="40.369" ry="40.358" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#fr)" stroke="url(#a)" stroke-dasharray="1.077999955415726" stroke-width="2.156" href="#bs"/>
    <g id="Oval-Copy-61" transform="translate(335.81 1024.4) rotate(90) translate(-335.81 -1024.4)" stroke-linejoin="square" stroke-width="5.39">
    <ellipse cx="335.81" cy="1024.4" rx="40.369" ry="40.358" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="335.81" cy="1024.4" rx="40.369" ry="40.358" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#fq)" stroke="url(#a)" stroke-dasharray="1.077999955415726" stroke-width="2.156" href="#br"/>
    <g id="Oval-Copy-65" transform="translate(230.16 957.87) rotate(90) translate(-230.16 -957.87)" stroke-linejoin="square" stroke-width="5.39">
    <ellipse cx="230.16" cy="957.87" rx="40.369" ry="40.358" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="230.16" cy="957.87" rx="40.369" ry="40.358" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#fp)" stroke="url(#a)" stroke-dasharray="1.077999955415726" stroke-width="2.156" href="#bq"/>
    <g id="Oval-Copy-66" transform="translate(126.37 851.26) rotate(90) translate(-126.37 -851.26)" stroke-linejoin="square" stroke-width="5.39">
    <ellipse cx="126.37" cy="851.26" rx="40.369" ry="40.358" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="126.37" cy="851.26" rx="40.369" ry="40.358" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#fo)" stroke="url(#a)" stroke-dasharray="1.077999955415726" stroke-width="2.156" href="#bo"/>
    <g id="Oval-Copy-67" transform="translate(69.118 726.03) rotate(90) translate(-69.118 -726.03)" stroke-linejoin="square" stroke-width="5.39">
    <ellipse cx="69.118" cy="726.03" rx="40.369" ry="40.358" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="69.118" cy="726.03" rx="40.369" ry="40.358" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#fn)" stroke="url(#a)" stroke-dasharray="1.077999955415726" stroke-width="2.156" href="#bn"/>
    <g id="Oval-Copy-56" transform="translate(601.58 1067.3) rotate(90) translate(-601.58 -1067.3)" stroke-linejoin="square" stroke-width="5.39">
    <ellipse cx="601.58" cy="1067.3" rx="40.369" ry="40.358" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="601.58" cy="1067.3" rx="40.369" ry="40.358" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#fm)" stroke="url(#a)" stroke-dasharray="1.077999955415726" stroke-width="2.156" href="#bm"/>
    <g id="Oval-Copy-58" transform="translate(733.3 1043.1) rotate(90) translate(-733.3 -1043.1)" stroke-linejoin="square" stroke-width="5.39">
    <ellipse cx="733.3" cy="1043.1" rx="40.369" ry="40.358" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="733.3" cy="1043.1" rx="40.369" ry="40.358" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#fk)" stroke="url(#a)" stroke-dasharray="1.077999955415726" stroke-width="2.156" href="#bl"/>
    <g id="Oval-Copy-63" transform="translate(864.55 973.7) rotate(90) translate(-864.55 -973.7)" stroke-linejoin="square" stroke-width="5.39">
    <ellipse cx="864.55" cy="973.7" rx="40.369" ry="40.358" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="864.55" cy="973.7" rx="40.369" ry="40.358" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#fj)" stroke="url(#a)" stroke-dasharray="1.077999955415726" stroke-width="2.156" href="#bk"/>
    <g id="Oval-Copy-69" transform="translate(963.69 871.74) rotate(90) translate(-963.69 -871.74)" stroke-linejoin="square" stroke-width="5.39">
    <ellipse cx="963.69" cy="871.74" rx="40.369" ry="40.358" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="963.69" cy="871.74" rx="40.369" ry="40.358" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#fi)" stroke="url(#a)" stroke-dasharray="1.077999955415726" stroke-width="2.156" href="#bj"/>
    <g id="Oval-Copy-70" transform="translate(1036.8 760.48) rotate(90) translate(-1036.8 -760.48)" stroke-linejoin="square" stroke-width="5.39">
    <ellipse cx="1036.8" cy="760.48" rx="40.369" ry="40.358" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="1036.8" cy="760.48" rx="40.369" ry="40.358" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#fh)" stroke="url(#a)" stroke-dasharray="1.077999955415726" stroke-width="2.156" href="#bi"/>
    <g id="Oval-Copy-71" transform="translate(1071.2 641.76) rotate(90) translate(-1071.2 -641.76)" stroke-linejoin="square" stroke-width="5.39">
    <ellipse cx="1071.2" cy="641.76" rx="40.369" ry="40.358" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="1071.2" cy="641.76" rx="40.369" ry="40.358" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#fg)" stroke="url(#a)" stroke-dasharray="1.077999955415726" stroke-width="2.156" href="#bh"/>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#ff)" stroke="url(#a)" stroke-dasharray="1.077999955415726" stroke-width="2.156" href="#bg"/>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#fe)" stroke="url(#a)" stroke-dasharray="1.077999955415726" stroke-width="2.156" href="#bf"/>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#fd)" stroke="url(#a)" stroke-dasharray="1.077999955415726" stroke-width="2.156" href="#be"/>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#fc)" stroke="url(#a)" stroke-dasharray="1.077999955415726" stroke-width="2.156" href="#bd"/>
    </g>
    <g transform="translate(746.9 744.7)" opacity=".1">
    <ellipse id="Oval" transform="translate(392.28 386.34) rotate(-90) translate(-392.28 -386.34)" cx="392.28" cy="386.34" rx="360.82" ry="360.89" stroke="url(#a)" stroke-width="3.773"/>
    <use id="Oval" transform="translate(392.27 386.66) rotate(-90) translate(-392.27 -386.66)" mask="url(#fb)" stroke="url(#a)" stroke-dasharray="1.077999955415726,11.85799970626831" stroke-width="14.014" href="#bb"/>
    <use id="Oval" transform="translate(392.27 386.66) rotate(-90) translate(-392.27 -386.66)" mask="url(#fa)" stroke="url(#a)" stroke-dasharray="1.131899917125702,3.773000073432923" stroke-width="2.2638" href="#ba"/>
    <g id="hg" transform="translate(455.97 35.359) rotate(-90) translate(-455.97 -35.359)" stroke-linejoin="square" stroke-width="3.773">
    <ellipse cx="455.97" cy="35.359" rx="28.258" ry="28.251" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="455.97" cy="35.359" rx="28.258" ry="28.251" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <g id="hh" transform="translate(548.17 59.474) rotate(-90) translate(-548.17 -59.474)" stroke-linejoin="square" stroke-width="3.773">
    <ellipse cx="548.17" cy="59.474" rx="28.258" ry="28.251" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="548.17" cy="59.474" rx="28.258" ry="28.251" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <g id="hn" transform="translate(621.48 106.08) rotate(-90) translate(-621.48 -106.08)" stroke-linejoin="square" stroke-width="3.773">
    <ellipse cx="621.48" cy="106.08" rx="28.258" ry="28.251" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="621.48" cy="106.08" rx="28.258" ry="28.251" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#ey)" stroke="url(#a)" stroke-dasharray="0.7545999884605409" stroke-width="1.5092" href="#az"/>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#ex)" stroke="url(#a)" stroke-dasharray="0.7545999884605409" stroke-width="1.5092" href="#ay"/>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#ew)" stroke="url(#a)" stroke-dasharray="0.7545999884605409" stroke-width="1.5092" href="#ax"/>
    <g id="hf" transform="translate(694.78 181.36) rotate(-90) translate(-694.78 -181.36)" stroke-linejoin="square" stroke-width="3.773">
    <ellipse cx="694.78" cy="181.36" rx="28.258" ry="28.251" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="694.78" cy="181.36" rx="28.258" ry="28.251" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#ev)" stroke="url(#a)" stroke-dasharray="0.7545999884605409" stroke-width="1.5092" href="#av"/>
    <g id="he" transform="translate(738.77 279.45) rotate(-90) translate(-738.77 -279.45)" stroke-linejoin="square" stroke-width="3.773">
    <ellipse cx="738.77" cy="279.45" rx="28.258" ry="28.251" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="738.77" cy="279.45" rx="28.258" ry="28.251" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#eu)" stroke="url(#a)" stroke-dasharray="0.7545999884605409" stroke-width="1.5092" href="#au"/>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#et)" stroke="url(#a)" stroke-dasharray="0.7545999884605409" stroke-width="1.5092" href="#at"/>
    <g id="hj" transform="translate(362.13 30.144) rotate(-90) translate(-362.13 -30.144)" stroke-linejoin="square" stroke-width="3.773">
    <ellipse cx="362.13" cy="30.144" rx="28.258" ry="28.251" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="362.13" cy="30.144" rx="28.258" ry="28.251" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <g id="hb" transform="translate(269.93 47.091) rotate(-90) translate(-269.93 -47.091)" stroke-linejoin="square" stroke-width="3.773">
    <ellipse cx="269.93" cy="47.091" rx="28.258" ry="28.251" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="269.93" cy="47.091" rx="28.258" ry="28.251" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <g id="hk" transform="translate(178.71 95.648) rotate(-90) translate(-178.71 -95.648)" stroke-linejoin="square" stroke-width="3.773">
    <ellipse cx="178.71" cy="95.648" rx="28.258" ry="28.251" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="178.71" cy="95.648" rx="28.258" ry="28.251" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <g id="hl" transform="translate(108.66 166.36) rotate(-90) translate(-108.66 -166.36)" stroke-linejoin="square" stroke-width="3.773">
    <ellipse cx="108.66" cy="166.36" rx="28.258" ry="28.251" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="108.66" cy="166.36" rx="28.258" ry="28.251" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#er)" stroke="url(#a)" stroke-dasharray="0.7545999884605409" stroke-width="1.5092" href="#as"/>
    <g id="hp" transform="translate(59.46 248.81) rotate(-90) translate(-59.46 -248.81)" stroke-linejoin="square" stroke-width="3.773">
    <ellipse cx="59.46" cy="248.81" rx="28.258" ry="28.251" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="59.46" cy="248.81" rx="28.258" ry="28.251" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <g id="hc" transform="translate(36.002 331.91) rotate(-90) translate(-36.002 -331.91)" stroke-linejoin="square" stroke-width="3.773">
    <ellipse cx="36.002" cy="331.91" rx="28.258" ry="28.251" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="36.002" cy="331.91" rx="28.258" ry="28.251" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#eq)" stroke="url(#a)" stroke-dasharray="0.7545999884605409" stroke-width="1.5092" href="#ar"/>
    <g transform="translate(30.137 415.02) rotate(-90) translate(-30.137 -415.02)" stroke-linejoin="square" stroke-width="3.773">
    <ellipse cx="30.137" cy="415.02" rx="28.258" ry="28.251" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="30.137" cy="415.02" rx="28.258" ry="28.251" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#ep)" stroke="url(#a)" stroke-dasharray="0.7545999884605409" stroke-width="1.5092" href="#aq"/>
    <g transform="translate(750.5 361.57) rotate(-90) translate(-750.5 -361.57)" stroke-linejoin="square" stroke-width="3.773">
    <ellipse cx="750.5" cy="361.57" rx="28.258" ry="28.251" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="750.5" cy="361.57" rx="28.258" ry="28.251" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#eo)" stroke="url(#a)" stroke-dasharray="0.7545999884605409" stroke-width="1.5092" href="#ap"/>
    <g transform="translate(326.95 741.88) rotate(90) translate(-326.95 -741.88)" stroke-linejoin="square" stroke-width="3.773">
    <ellipse cx="326.95" cy="741.88" rx="28.258" ry="28.251" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="326.95" cy="741.88" rx="28.258" ry="28.251" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#en)" stroke="url(#a)" stroke-dasharray="0.7545999884605409" stroke-width="1.5092" href="#ao"/>
    <g transform="translate(235.07 717.11) rotate(90) translate(-235.07 -717.11)" stroke-linejoin="square" stroke-width="3.773">
    <ellipse cx="235.07" cy="717.11" rx="28.258" ry="28.251" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="235.07" cy="717.11" rx="28.258" ry="28.251" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#em)" stroke="url(#a)" stroke-dasharray="0.7545999884605409" stroke-width="1.5092" href="#an"/>
    <g transform="translate(161.11 670.51) rotate(90) translate(-161.11 -670.51)" stroke-linejoin="square" stroke-width="3.773">
    <ellipse cx="161.11" cy="670.51" rx="28.258" ry="28.251" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="161.11" cy="670.51" rx="28.258" ry="28.251" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#el)" stroke="url(#a)" stroke-dasharray="0.7545999884605409" stroke-width="1.5092" href="#am"/>
    <g transform="translate(88.457 595.88) rotate(90) translate(-88.457 -595.88)" stroke-linejoin="square" stroke-width="3.773">
    <ellipse cx="88.457" cy="595.88" rx="28.258" ry="28.251" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="88.457" cy="595.88" rx="28.258" ry="28.251" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#ek)" stroke="url(#a)" stroke-dasharray="0.7545999884605409" stroke-width="1.5092" href="#al"/>
    <g transform="translate(48.382 508.22) rotate(90) translate(-48.382 -508.22)" stroke-linejoin="square" stroke-width="3.773">
    <ellipse cx="48.382" cy="508.22" rx="28.258" ry="28.251" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="48.382" cy="508.22" rx="28.258" ry="28.251" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#ej)" stroke="url(#a)" stroke-dasharray="0.7545999884605409" stroke-width="1.5092" href="#ak"/>
    <g transform="translate(421.11 747.09) rotate(90) translate(-421.11 -747.09)" stroke-linejoin="square" stroke-width="3.773">
    <ellipse cx="421.11" cy="747.09" rx="28.258" ry="28.251" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="421.11" cy="747.09" rx="28.258" ry="28.251" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#ei)" stroke="url(#a)" stroke-dasharray="0.7545999884605409" stroke-width="1.5092" href="#aj"/>
    <g transform="translate(513.31 730.15) rotate(90) translate(-513.31 -730.15)" stroke-linejoin="square" stroke-width="3.773">
    <ellipse cx="513.31" cy="730.15" rx="28.258" ry="28.251" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="513.31" cy="730.15" rx="28.258" ry="28.251" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#eh)" stroke="url(#a)" stroke-dasharray="0.7545999884605409" stroke-width="1.5092" href="#ah"/>
    <g transform="translate(605.19 681.59) rotate(90) translate(-605.19 -681.59)" stroke-linejoin="square" stroke-width="3.773">
    <ellipse cx="605.19" cy="681.59" rx="28.258" ry="28.251" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="605.19" cy="681.59" rx="28.258" ry="28.251" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#eg)" stroke="url(#a)" stroke-dasharray="0.7545999884605409" stroke-width="1.5092" href="#ag"/>
    <g transform="translate(674.58 610.22) rotate(90) translate(-674.58 -610.22)" stroke-linejoin="square" stroke-width="3.773">
    <ellipse cx="674.58" cy="610.22" rx="28.258" ry="28.251" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="674.58" cy="610.22" rx="28.258" ry="28.251" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#ef)" stroke="url(#a)" stroke-dasharray="0.7545999884605409" stroke-width="1.5092" href="#af"/>
    <g transform="translate(725.74 532.33) rotate(90) translate(-725.74 -532.33)" stroke-linejoin="square" stroke-width="3.773">
    <ellipse cx="725.74" cy="532.33" rx="28.258" ry="28.251" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="725.74" cy="532.33" rx="28.258" ry="28.251" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#ee)" stroke="url(#a)" stroke-dasharray="0.7545999884605409" stroke-width="1.5092" href="#ae"/>
    <g transform="translate(749.84 449.23) rotate(90) translate(-749.84 -449.23)" stroke-linejoin="square" stroke-width="3.773">
    <ellipse cx="749.84" cy="449.23" rx="28.258" ry="28.251" fill="#111" fill-rule="evenodd" stroke="url(#a)"/>
    <ellipse cx="749.84" cy="449.23" rx="28.258" ry="28.251" stroke="#000" stroke-opacity=".48997"/>
    </g>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#ed)" stroke="url(#a)" stroke-dasharray="0.7545999884605409" stroke-width="1.5092" href="#ad"/>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#ec)" stroke="url(#a)" stroke-dasharray="0.7545999884605409" stroke-width="1.5092" href="#ac"/>
    <use id="Oval-Copy-118" fill="#111111" mask="url(#eb)" stroke="url(#a)" stroke-dasharray="0.7545999884605409" stroke-width="1.5092" href="#ab"/>
    <use id="ho" fill="#111111" mask="url(#ea)" stroke="url(#a)" stroke-dasharray="0.7545999884605409" stroke-width="1.5092" href="#z"/>
    <use fill="#111111" mask="url(#dz)" stroke="url(#a)" stroke-dasharray="0.7545999884605409" stroke-width="1.5092" href="#y"/>
    </g>
    </g>
    </g>
    </g>
    </svg>
    
    )
}









export const RightArrow = (props) => {
    return (

        <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 512 512" space="preserve">
            <g>
                <g>
                    <path d="M506.134,241.843c-0.006-0.006-0.011-0.013-0.018-0.019l-104.504-104c-7.829-7.791-20.492-7.762-28.285,0.068
			c-7.792,7.829-7.762,20.492,0.067,28.284L443.558,236H20c-11.046,0-20,8.954-20,20c0,11.046,8.954,20,20,20h423.557
			l-70.162,69.824c-7.829,7.792-7.859,20.455-0.067,28.284c7.793,7.831,20.457,7.858,28.285,0.068l104.504-104
			c0.006-0.006,0.011-0.013,0.018-0.019C513.968,262.339,513.943,249.635,506.134,241.843z"/>
                </g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
        </svg>

    )
}




export const RefreshLogo = (props) => {
    return (



        <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 491.236 491.236" space="preserve">
            <g>
                <g>
                    <path d="M55.89,262.818c-3-26-0.5-51.1,6.3-74.3c22.6-77.1,93.5-133.8,177.6-134.8v-50.4c0-2.8,3.5-4.3,5.8-2.6l103.7,76.2c1.7,1.3,1.7,3.9,0,5.1l-103.6,76.2c-2.4,1.7-5.8,0.2-5.8-2.6v-50.3c-55.3,0.9-102.5,35-122.8,83.2c-7.7,18.2-11.6,38.3-10.5,59.4c1.5,29,12.4,55.7,29.6,77.3c9.2,11.5,7,28.3-4.9,37c-11.3,8.3-27.1,6-35.8-5C74.19,330.618,59.99,298.218,55.89,262.818zM355.29,166.018c17.3,21.5,28.2,48.3,29.6,77.3c1.1,21.2-2.9,41.3-10.5,59.4c-20.3,48.2-67.5,82.4-122.8,83.2v-50.3c0-2.8-3.5-4.3-5.8-2.6l-103.7,76.2c-1.7,1.3-1.7,3.9,0,5.1l103.6,76.2c2.4,1.7,5.8,0.2,5.8-2.6v-50.4c84.1-0.9,155.1-57.6,177.6-134.8c6.8-23.2,9.2-48.3,6.3-74.3c-4-35.4-18.2-67.8-39.5-94.4c-8.8-11-24.5-13.3-35.8-5C348.29,137.718,346.09,154.518,355.29,166.018z" />
                </g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
        </svg>


    )
}







export const Tick = () => {
    return (


        <svg width="27px" height="24px" viewBox="0 0 27 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink">
            <title>Shape</title>
            <desc>Created with Sketch.</desc>
            <g id="Home-Page" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="ZUZ-home-page" transform="translate(-1704.000000, -3539.000000)" fill="rgba(137,84,244,1)">
                    <g id="&gt;-03---HOW-DO-I-JOIN" transform="translate(-3058.000000, 2237.000000)">
                        <g id="01---02-MESSAGES" transform="translate(3469.000000, 321.000000)">
                            <g id="Group-5" transform="translate(1293.000000, 981.000000)">
                                <path d="M26.4,12 L23.4113987,8.82928674 L23.8793324,4.58451799 L19.5092322,3.70043988 L17.2800422,0 L13.2000258,1.74240493 L9.12000939,0 L6.89081946,3.70043988 L2.52071924,4.58451799 L2.98860132,8.82928674 L7.28306304e-13,12 L2.98854969,15.1707133 L2.52066761,19.415482 L6.89076783,20.2995601 L9.11995776,24 L13.1999742,22.2575457 L17.2799906,24 L19.5091805,20.2995601 L23.8792808,19.415482 L23.4113471,15.1707133 L26.4,12 Z M18.975,8.97586234 L12.1604092,16 L7.425,11.6433269 L8.55132291,10.6070868 L12.0946234,13.8669956 L17.7866611,8 L18.975,8.97586234 Z" id="Shape"></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    )
}











export const Profile = () => {

    return (

        <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24" viewBox="0 0 24 24" width="24" fill="rgb(255,255,255)"><g><path d="M0,0h24v24H0V0z" fill="none" /></g><g><g><path d="M10.67,13.02C10.45,13.01,10.23,13,10,13c-2.42,0-4.68,0.67-6.61,1.82C2.51,15.34,2,16.32,2,17.35V19c0,0.55,0.45,1,1,1 h8.26C10.47,18.87,10,17.49,10,16C10,14.93,10.25,13.93,10.67,13.02z" /><circle cx="10" cy="8" r="4" /><path d="M20.75,16c0-0.22-0.03-0.42-0.06-0.63l0.84-0.73c0.18-0.16,0.22-0.42,0.1-0.63l-0.59-1.02c-0.12-0.21-0.37-0.3-0.59-0.22 l-1.06,0.36c-0.32-0.27-0.68-0.48-1.08-0.63l-0.22-1.09c-0.05-0.23-0.25-0.4-0.49-0.4h-1.18c-0.24,0-0.44,0.17-0.49,0.4 l-0.22,1.09c-0.4,0.15-0.76,0.36-1.08,0.63l-1.06-0.36c-0.23-0.08-0.47,0.02-0.59,0.22l-0.59,1.02c-0.12,0.21-0.08,0.47,0.1,0.63 l0.84,0.73c-0.03,0.21-0.06,0.41-0.06,0.63s0.03,0.42,0.06,0.63l-0.84,0.73c-0.18,0.16-0.22,0.42-0.1,0.63l0.59,1.02 c0.12,0.21,0.37,0.3,0.59,0.22l1.06-0.36c0.32,0.27,0.68,0.48,1.08,0.63l0.22,1.09c0.05,0.23,0.25,0.4,0.49,0.4h1.18 c0.24,0,0.44-0.17,0.49-0.4l0.22-1.09c0.4-0.15,0.76-0.36,1.08-0.63l1.06,0.36c0.23,0.08,0.47-0.02,0.59-0.22l0.59-1.02 c0.12-0.21,0.08-0.47-0.1-0.63l-0.84-0.73C20.72,16.42,20.75,16.22,20.75,16z M17,18c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2 S18.1,18,17,18z" /></g></g></svg>
    )
}




export const MoreHoriz = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24" viewBox="0 0 24 24" width="24" fill="rgb(255,255,255)"><g><path d="M0,0h24v24H0V0z" fill="none" /></g><g><g><g><path d="M6,10c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2S7.1,10,6,10z M18,10c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2S19.1,10,18,10z M12,10c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2S13.1,10,12,10z" /></g></g></g></svg>
    )
}



export const EthereumIcon = () => {
    return (
        <svg width="33px" height="52px" viewBox="0 0 33 52" version="1.1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink">
            <title>Combined Shape</title>
            <desc>Created with Sketch.</desc>
            <g id="Home-Page" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <path d="M16.5,0 L0,29.7138171 L16.5,52 L33,29.7138171 L16.5,0 Z M14.8809243,44.3460435 L6.95716809,33.6449364 L14.8809243,37.2119721 L14.8809243,44.3460435 Z M14.8809243,29.5858959 L14.8809243,33.6219762 L4.21121578,28.8200082 L14.8809243,9.60557606 L14.8809243,30.138197 L18.1190757,30.138197 L18.1190757,9.60557606 L28.7887842,28.8200082 L18.1190757,33.6219762 L18.1190757,29.5858959 L14.8809243,29.5858959 Z M18.1190757,44.3460435 L18.1190757,37.2119721 L26.0428319,33.6449364 L18.1190757,44.3460435 Z" id="Combined-Shape" fill="#000000" fill-rule="nonzero"></path>
            </g>
        </svg>
    )
}






export const DotsBox = () => {
    return (

        <svg width="150px" height="316px" viewBox="0 0 150 316" version="1.1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink">
            <title>Group 2 Copy 3</title>
            <desc>Created with Sketch.</desc>
            <g id="Home-Page" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="ZUZ-home-page" transform="translate(-1380.000000, -504.000000)" fill="#2DDCF4" stroke="#2DDCF4" stroke-width="2">
                    <g id="&gt;-01---HERO-SCREEN" transform="translate(-2.000000, 0.000000)">
                        <g id="join-now" transform="translate(1255.000000, 506.000000)">
                            <g id="Group-2-Copy-3" transform="translate(202.000000, 156.000000) rotate(-270.000000) translate(-202.000000, -156.000000) translate(46.000000, 83.000000)">
                                <circle id="Oval" cx="1.5" cy="1.5" r="2.5"></circle>
                                <circle id="Oval-Copy-24" cx="1.5" cy="58.5" r="2.5"></circle>
                                <circle id="Oval-Copy-40" cx="1.5" cy="115.5" r="2.5"></circle>
                                <circle id="Oval-Copy-16" cx="1.5" cy="30.5" r="2.5"></circle>
                                <circle id="Oval-Copy-25" cx="1.5" cy="87.5" r="2.5"></circle>
                                <circle id="Oval-Copy-41" cx="1.5" cy="144.5" r="2.5"></circle>
                                <circle id="Oval-Copy-2" cx="94.5" cy="1.5" r="2.5"></circle>
                                <circle id="Oval-Copy-26" cx="94.5" cy="58.5" r="2.5"></circle>
                                <circle id="Oval-Copy-42" cx="94.5" cy="115.5" r="2.5"></circle>
                                <circle id="Oval-Copy-17" cx="94.5" cy="30.5" r="2.5"></circle>
                                <circle id="Oval-Copy-27" cx="94.5" cy="87.5" r="2.5"></circle>
                                <circle id="Oval-Copy-43" cx="94.5" cy="144.5" r="2.5"></circle>
                                <circle id="Oval-Copy-4" cx="228.5" cy="1.5" r="2.5"></circle>
                                <circle id="Oval-Copy-28" cx="228.5" cy="58.5" r="2.5"></circle>
                                <circle id="Oval-Copy-44" cx="228.5" cy="115.5" r="2.5"></circle>
                                <circle id="Oval-Copy-18" cx="228.5" cy="30.5" r="2.5"></circle>
                                <circle id="Oval-Copy-29" cx="228.5" cy="87.5" r="2.5"></circle>
                                <circle id="Oval-Copy-45" cx="228.5" cy="144.5" r="2.5"></circle>
                                <circle id="Oval-Copy" cx="42.5" cy="1.5" r="2.5"></circle>
                                <circle id="Oval-Copy-30" cx="42.5" cy="58.5" r="2.5"></circle>
                                <circle id="Oval-Copy-46" cx="42.5" cy="115.5" r="2.5"></circle>
                                <circle id="Oval-Copy-19" cx="42.5" cy="30.5" r="2.5"></circle>
                                <circle id="Oval-Copy-31" cx="42.5" cy="87.5" r="2.5"></circle>
                                <circle id="Oval-Copy-47" cx="42.5" cy="144.5" r="2.5"></circle>
                                <circle id="Oval-Copy-5" cx="187.5" cy="1.5" r="2.5"></circle>
                                <circle id="Oval-Copy-32" cx="187.5" cy="58.5" r="2.5"></circle>
                                <circle id="Oval-Copy-48" cx="187.5" cy="115.5" r="2.5"></circle>
                                <circle id="Oval-Copy-20" cx="187.5" cy="30.5" r="2.5"></circle>
                                <circle id="Oval-Copy-33" cx="187.5" cy="87.5" r="2.5"></circle>
                                <circle id="Oval-Copy-49" cx="187.5" cy="144.5" r="2.5"></circle>
                                <circle id="Oval-Copy-3" cx="142.5" cy="1.5" r="2.5"></circle>
                                <circle id="Oval-Copy-34" cx="142.5" cy="58.5" r="2.5"></circle>
                                <circle id="Oval-Copy-50" cx="142.5" cy="115.5" r="2.5"></circle>
                                <circle id="Oval-Copy-21" cx="142.5" cy="30.5" r="2.5"></circle>
                                <circle id="Oval-Copy-35" cx="142.5" cy="87.5" r="2.5"></circle>
                                <circle id="Oval-Copy-51" cx="142.5" cy="144.5" r="2.5"></circle>
                                <circle id="Oval-Copy-6" cx="269.5" cy="1.5" r="2.5"></circle>
                                <circle id="Oval-Copy-36" cx="269.5" cy="58.5" r="2.5"></circle>
                                <circle id="Oval-Copy-52" cx="269.5" cy="115.5" r="2.5"></circle>
                                <circle id="Oval-Copy-22" cx="269.5" cy="30.5" r="2.5"></circle>
                                <circle id="Oval-Copy-37" cx="269.5" cy="87.5" r="2.5"></circle>
                                <circle id="Oval-Copy-53" cx="269.5" cy="144.5" r="2.5"></circle>
                                <circle id="Oval-Copy-7" cx="310.5" cy="1.5" r="2.5"></circle>
                                <circle id="Oval-Copy-38" cx="310.5" cy="58.5" r="2.5"></circle>
                                <circle id="Oval-Copy-54" cx="310.5" cy="115.5" r="2.5"></circle>
                                <circle id="Oval-Copy-23" cx="310.5" cy="30.5" r="2.5"></circle>
                                <circle id="Oval-Copy-39" cx="310.5" cy="87.5" r="2.5"></circle>
                                <circle id="Oval-Copy-55" cx="310.5" cy="144.5" r="2.5"></circle>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    )
}





export const TwitterIcon = () => {
    return (
        <svg width="31px" height="25px" viewBox="0 0 31 25" version="1.1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink">
            <title>Path</title>
            <desc>Created with Sketch.</desc>
            <g id="Home-Page" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="ZUZ-home-page" transform="translate(-536.000000, -11070.000000)" fill="#FFFFFF" fill-rule="nonzero">
                    <g id="&gt;-05---FOOTER" transform="translate(-529.000000, 10345.000000)">
                        <g id="bottom-panel-for-footer" transform="translate(961.000000, 664.000000)">
                            <g id="Group-14" transform="translate(84.000000, 38.000000)">
                                <g id="Group-31">
                                    <path d="M51,25.9596154 C49.8471875,26.4615385 48.6188125,26.7942308 47.338125,26.9557692 C48.655625,26.175 49.6611875,24.9480769 50.1339375,23.4692308 C48.9055625,24.1961538 47.5493125,24.7096154 46.1039375,24.9961538 C44.9375625,23.7634615 43.2751875,23 41.4616875,23 C37.9431875,23 35.1105625,25.8346154 35.1105625,29.3096154 C35.1105625,29.8096154 35.1531875,30.2903846 35.2578125,30.7480769 C29.97425,30.4923077 25.2990625,27.9788462 22.158375,24.15 C21.6100625,25.0942308 21.2884375,26.175 21.2884375,27.3384615 C21.2884375,29.5230769 22.421875,31.4596154 24.111375,32.5807692 C23.0903125,32.5615385 22.088625,32.2673077 21.24,31.8038462 C21.24,31.8230769 21.24,31.8480769 21.24,31.8730769 C21.24,34.9384615 23.4429375,37.4846154 26.33175,38.0711538 C25.8144375,38.2115385 25.250625,38.2788462 24.6655,38.2788462 C24.258625,38.2788462 23.847875,38.2557692 23.4623125,38.1711538 C24.28575,40.6692308 26.622375,42.5057692 29.40075,42.5653846 C27.2385,44.2442308 24.4930625,45.2557692 21.5209375,45.2557692 C20.99975,45.2557692 20.499875,45.2326923 20,45.1692308 C22.8151875,46.9711538 26.1515625,48 29.7495,48 C41.44425,48 47.838,38.3846154 47.838,30.05 C47.838,29.7711538 47.8283125,29.5019231 47.81475,29.2346154 C49.0760625,28.3461538 50.135875,27.2365385 51,25.9596154 Z" id="Path"></path>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    )
}



export const ArrowFly = () => {
    return (
        <svg width="31px" height="26px" viewBox="0 0 31 26" version="1.1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink">
            <title>Path Copy</title>
            <desc>Created with Sketch.</desc>
            <g id="Home-Page" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="ZUZ-home-page" transform="translate(-1087.000000, -11069.000000)" fill="#FFFFFF" fill-rule="nonzero">
                    <g id="&gt;-05---FOOTER" transform="translate(-529.000000, 10345.000000)">
                        <g id="bottom-panel-for-footer" transform="translate(961.000000, 664.000000)">
                            <g id="Group-14" transform="translate(84.000000, 38.000000)">
                                <g id="Group-28" transform="translate(532.000000, 0.000000)">
                                    <path d="M51.1641468,39.1357389 L50.6513429,46.3949015 C51.3850272,46.3949015 51.7027848,46.0777031 52.0838356,45.6968051 L55.5236265,42.3883221 L62.6512144,47.6415951 C63.9584124,48.3747913 64.8793929,47.9886933 65.2320263,46.4313013 L69.9105554,24.3678149 L69.9118471,24.366515 C70.326482,22.421725 69.2130386,21.6612289 67.9394247,22.1383264 L40.439181,32.7345719 C38.5623442,33.4677681 38.5907616,34.5207627 40.1201316,34.9978602 L47.1508421,37.1987489 L63.481776,26.9145018 C64.2503361,26.4023045 64.9491446,26.685703 64.3743391,27.1979004 L51.1641468,39.1357389 Z" id="Path-Copy"></path>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    )
}



export const YoutubeIcon = () => {
    return (

        <svg width="32px" height="23px" viewBox="0 0 32 23" version="1.1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink">
            <title>Shape</title>
            <desc>Created with Sketch.</desc>
            <g id="Home-Page" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="ZUZ-home-page" transform="translate(-1354.000000, -11071.000000)" fill="#FFFFFF" fill-rule="nonzero">
                    <g id="&gt;-05---FOOTER" transform="translate(-529.000000, 10345.000000)">
                        <g id="bottom-panel-for-footer" transform="translate(961.000000, 664.000000)">
                            <g id="Group-14" transform="translate(84.000000, 38.000000)">
                                <g id="Group-29" transform="translate(819.000000, 0.000000)">
                                    <path d="M50.3405547,27.5989504 C49.9718055,26.1916506 48.8909485,25.0822916 47.5202485,24.7033492 C45.0161526,24 34.9995735,24 34.9995735,24 C34.9995735,24 24.983385,24 22.4792891,24.6766828 C21.1349562,25.0552243 20.0277321,26.191851 19.6589829,27.5989504 C19,30.1693429 19,35.5 19,35.5 C19,35.5 19,40.8575239 19.6589829,43.4010496 C20.0281227,44.808149 21.108589,45.9175079 22.4794844,46.2964503 C25.0097521,47 34.9999641,47 34.9999641,47 C34.9999641,47 45.0161526,47 47.5202485,46.3233172 C48.8911439,45.9445752 49.9718055,44.8352163 50.3409453,43.4281169 C50.9998674,40.8575239 50.9998674,35.5270673 50.9998674,35.5270673 C50.9998674,35.5270673 51.0261,30.1693429 50.3405547,27.5989504 L50.3405547,27.5989504 Z M31.8105182,40.4246474 L31.8105182,30.5753526 L40.1397963,35.5 L31.8105182,40.4246474 Z" id="Shape"></path>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    )
}
































export const RightKeyboardArrow = () => {
    return (

        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z" /></svg>
    )
}



export const ArrowUp = () => {
    return (

        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z" /></svg>
    )
}

export const VideoPlay = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0z" fill="none" /><path d="M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" /></svg>
    )
}

export default ChainCircle;